/* eslint no-param-reassign: "off" */

import { words, aliases } from '../dictionary';

export default {
  install(Vue) {
    // set up aliases
    Vue.prototype.$dictionary = {
      exists(key, folder) {
        if (folder && this.words[folder] && this.words[folder][key]) return true;
        return !folder && this.words[key];
      },
      test(val) {
        return val || val === '';
      },
      get(key, dir, sub) {
        if (dir && this.words[dir]) {
          if ((sub && this.words[dir][sub]) && this.test(this.words[dir][sub][key])) {
            return this.words[dir][sub][key];
          }
          if (this.test(this.words[dir][key])) {
            return this.words[dir][key];
          }
        }
        if (key && this.test(this.words[key])) return this.words[key];
        let err = '';
        if (!key) err = 'no key specified!';
        else if (!dir) err = key;
        else if (!sub) err = `${dir}.${key}`;
        else err = `${dir}.${sub}.${key}`;
        // console.log('Word not found: %c%s', 'color: red;', err);
        return `⚠  ${err}`;
      },
      aliases,
      words,
    };
  },
};
